import { motion } from "framer-motion";

export const PageWrap = ({ children, testId }) => (
  <motion.main
    data-testid={testId}
    initial={{ opacity: 0, y: 26 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -18 }}
    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className="min-h-screen"
  >
    {children}
  </motion.main>
);
